import { render } from "./DeveloperItemLabel.vue?vue&type=template&id=46739569"
import script from "./DeveloperItemLabel.vue?vue&type=script&lang=js"
export * from "./DeveloperItemLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__